
export const PublicSellerReturnsQuery = new TypedDocumentString(`
    query PublicSellerReturnsQuery($sellerId: ObjectId!) {
  publicSellerReturns(sellerId: $sellerId) {
    ...ProductExtraReturn
    __typename
  }
}
    fragment Duration on Duration {
  unit
  value
  __typename
}
fragment ProductExtraReturn on ProductExtraReturn {
  id
  returnsNotAllowed
  document {
    _id
    __typename
  }
  title {
    value
    __typename
  }
  message {
    value
    __typename
  }
  duration {
    ...Duration
    __typename
  }
  __typename
}`, {"hash":"634ce1bc022c31e2fc21f32a7821ada8fb4afd366d2d0466bfe608fc34f505d7"});